import { HelpOutline } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import React from 'react';

import { useSxStyles } from './useStyles';

export const InstructionButton = (props: IconButtonProps) => {
  const { sx, children, ...buttonProps } = props;

  const sxStyles = useSxStyles();

  const iconFontSizeOptions: SvgIconProps['fontSize'][] = [
    'small',
    'medium',
    'large',
  ];

  const iconProps: SvgIconProps = {
    fontSize: iconFontSizeOptions.find((s) => s === buttonProps.size),
  };

  return (
    <IconButton {...buttonProps} sx={{ ...sxStyles.help, ...sx }}>
      {!!children ? children : <HelpOutline {...iconProps} />}
    </IconButton>
  );
};
